module.exports = __webpack_public_path__ + "img/downloads.67608aa3.svg";